module.exports = __webpack_public_path__ + "static/img/two-codes.5f9747b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./static/images/two-codes.png
 ** module id = 343
 ** module chunks = 3
 **/